/**
 * Константы для таймеров и интервалов (используемые в приложении).
 * Базовые единицы времени — в constants.ts (TIME_INTERVALS, DEBOUNCE_INTERVALS, ANIMATION_DURATIONS).
 */

export const TIMER_CONSTANTS = {
  IMMEDIATE: 0,
  FAST: 100,
  STANDARD: 1000,
  SLOW: 2000,
  VERY_SLOW: 5000,
  SEARCH_TIMEOUT: 250,
  AUTO_CLOSE_TIMEOUT: 2000,
} as const;

export const INTERVAL_CONSTANTS = {
  VERY_FREQUENT: 100,
  FREQUENT: 500,
  STANDARD: 1000,
  RARE: 5000,
  VERY_RARE: 30000,
} as const;

export const AUTO_CLOSE_TIMES = {
  FAST: 2000,
  STANDARD: 5000,
  SLOW: 10000,
  VERY_SLOW: 15000,
} as const;

